import { TableCell, TableRow } from "@material-ui/core";
import {
	DatatablesFooterServerSide,
	Loading,
	TableAction,
} from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import { defaultDateDisplay } from "App/utils/helpers";
import { FreezeTable } from "components/organism";
import { StatusOrganisasi } from "pages/SatuSehat/utils";
import { deleteOrganisasi, headCellsOrganisasi } from "./helpers";
import useModalDelete from "./hooks/useModalDelete";

export default function OrganisasiTable({
	rows,
	handleClickEdit,
	handleChildren,
	totalData,
	resetPagination,
	setNewData,
	pagination,
	onPrevious,
	onNext,
	handleClickPageNumber,
	handleChangeLimit,
	loading,
	handleChange,
	children,
}) {
	const { order, orderBy, handleRequestSort, length } = useDatatables({
		rows: rows,
		orderByDefault: "date",
		orderByRow: ["date", "id"],
	});

	const { ModalDelete, handleClickDelete } = useModalDelete({
		setNewData,
		children,
		handleClickYes: deleteOrganisasi,
	});

	return (
		<>
			<ModalDelete />
			<Loading show={loading} />

			<FreezeTable
				headCells={headCellsOrganisasi}
				handleRequestSort={handleRequestSort}
				order={order}
				length={length}
				orderBy={orderBy}
			>
				{stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
					return (
						<TableRow key={index}>
							<TableCell align="center">{index + 1}</TableCell>
							<TableCell align="center">
								<TableAction
									clickDelete={() => handleClickDelete(row.id_organization)}
									clickUpdate={() => handleClickEdit(row)}
									isSelect={true}
									clickSelect={() => handleChildren(row)}
								/>
							</TableCell>
							<TableCell align="left">{row?.kode}</TableCell>
							<TableCell align="left">{row?.name}</TableCell>
							<TableCell align="left">{row?.alias}</TableCell>
							<TableCell align="center">
								<StatusOrganisasi status={row.active} />
							</TableCell>
							<TableCell align="left">
								{defaultDateDisplay(row?.createdAt)}
							</TableCell>
							<TableCell align="left">{row?.createdBy}</TableCell>
							<TableCell align="left">
								{defaultDateDisplay(row?.updatedAt)}
							</TableCell>
							<TableCell align="left">{row?.updatedBy}</TableCell>
						</TableRow>
					);
				})}
				{rows.length === 0 && (
					<TableRow>
						<TableCell align="center" colSpan={headCellsOrganisasi.length}>
							Tidak ada data
						</TableCell>
					</TableRow>
				)}
			</FreezeTable>
			<DatatablesFooterServerSide
				totalData={totalData}
				pagination={pagination}
				handleChangeLimit={handleChangeLimit}
				onPrevious={onPrevious}
				onNext={onNext}
				currentPage={pagination.page}
				handleClickPageNumber={handleClickPageNumber}
			/>
		</>
	);
}
